export const homepage: object = {
  homepage: {
    recentlyAdded: 'Recently Added',
    error: {
      header: 'It seems something went wrong...',
      line1: 'We’re not sure how you ended up here. This might be due to an authentication or navigation issue. Use your browser’s back button to return and try again. ',
      line2: 'If the issue persists, log in again or restart from your original entry point.',
    }
  }
};
